import { Button } from 'components/Button';
import { TextField } from 'components/Field/TextField';
import { ICONS } from 'components/Icon';
import { useSelector } from 'hooks/useSelector';
import { noop } from 'lodash';
import * as React from 'react';
import { useState } from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import { AUTHENTICATE, RESET_AUTH_STEP } from 'store/actions';
import { selectUserEmailWithAuthStepEmail } from 'store/auth/selectors';

import { Card } from 'components/Card';
import { useAlert } from 'hooks/useAlert';
import { useForceUpdate } from 'hooks/useForceUpdate';
import { styles } from './styles';
import { UserChip } from './UserChip';
import { ButtonGroup } from 'components/ButtonGroup';

export const SetPassword: React.FC = () => {
  const dispatch = useDispatch();
  const alert = useAlert();
  const forceUpdate = useForceUpdate();
  const [password, setPassword] = useState('');
  const autoFocusOnNextRenderRef = React.useRef<boolean>(true);
  const email = useSelector(selectUserEmailWithAuthStepEmail);

  const handleBack = () => {
    dispatch(RESET_AUTH_STEP());
  };
  const handleSubmit = () => {
    if (password) {
      dispatch(AUTHENTICATE.request({ password }));
    }
  };

  const handleShowPasswordTips = () => {
    alert({
      title: 'Password Tips',
      text:
        '***Make it Long & Memorable***\n' +
        'We advise choosing a password that’s at least 12 characters long. ' +
        'Try using a sentence as your password: lyrics from a song, a quote from a film, a passage from a book, etc.\n\n' +
        '***Don’t Use Personal Info***\n' +
        'Avoid including info about yourself that others might know or could easily find out, for example: ' +
        'your nickname, your pet’s name, important birthdays or years, numbers from your address, etc.\n\n' +
        '***Don’t Use Common Words & Patterns***\n' +
        'Avoid words like ‘password’, ‘letmein’, ‘qwerty’, ‘123abc’, etc.',
      onConfirm: () => {
        forceUpdate();
      },
    });
    autoFocusOnNextRenderRef.current = false;
    forceUpdate();
  };

  const autoFocus = autoFocusOnNextRenderRef.current;
  autoFocusOnNextRenderRef.current = true;

  return (
    <>
      <UserChip />
      <TextField
        inputMode="email"
        autoComplete="email"
        onChange={noop}
        value={email}
        containerStyle={{ left: -999, position: 'absolute', top: -999 }}
      />
      <Card
        label="Create a New Password"
        style={styles.textFieldContainer}
        explanationLinkText="Tips on choosing a strong password"
        onExplanationLinkPress={handleShowPasswordTips}
      >
        <TextField
          placeholder="New Password"
          onChange={setPassword}
          secureTextEntry
          autoComplete="newPassword"
          autoCapitalize="none"
          autoCorrect={false}
          onSubmitEditing={handleSubmit}
          returnKeyType="next"
          enablesReturnKeyAutomatically
          onChangeDebounceMs={0}
          // Will re-focus field if an API error comes back
          autoFocusEveryRender={autoFocus}
          key={autoFocus ? 'withAutoFocus' : 'withoutAutoFocus'}
        />
      </Card>
      <View style={styles.buttonContainer}>
        <ButtonGroup>
          <Button onPress={handleBack} text="Back" />
          <Button
            disabled={!password}
            icon={ICONS.ChevronRightSolid}
            onPress={handleSubmit}
            text="Next"
          />
        </ButtonGroup>
      </View>
    </>
  );
};
